import { render, staticRenderFns } from "./ZonePresidentList.vue?vue&type=template&id=e3848276"
import script from "./ZonePresidentList.vue?vue&type=script&lang=js"
export * from "./ZonePresidentList.vue?vue&type=script&lang=js"
import style0 from "./ZonePresidentList.vue?vue&type=style&index=0&id=e3848276&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports